import {
  MultiSelect as MantineMultiSelect,
  type MultiSelectProps,
} from "@mantine/core";
import { forwardRef, useMemo } from "react";
import { normalizeSelectData } from "src/utils/mantineComboboxData";

export type { MultiSelectProps };

const MultiSelect = forwardRef<HTMLInputElement, MultiSelectProps>(
  ({ data, ...props }, ref) => {
    const normalizedData = useMemo(
      () => (data ? normalizeSelectData(data) : data),
      [data],
    );

    return <MantineMultiSelect {...props} ref={ref} data={normalizedData} />;
  },
);

MultiSelect.displayName = "MultiSelect";

export default MultiSelect;
